import { createContext } from 'react';

import type { Text } from 'src/__generated__/graphqlTypes';
import { BlockPosition } from 'src/shared/lib/section-extra-components/constants';

export const ExtraComponents = createContext<null | Record<BlockPosition, Array<Text>>>(null);
